// ======================================================================
// File Name       : ProgressStatusCSVDownloadContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import * as GroupAction from '../../../actions/GroupAction';
import * as ModalAction from '../../../actions/ModalAction';
import * as csvDownloadActionCreators from '../../../actions/actionCreators/csvDownload';
import * as csvDownloadActions from '../../../actions/csvDownloadAction';
import DialogConfirm from '../../../components/DialogConfirm';
import Header from '../../../components/Header';
import CustomLink from '../../../components/button/CustomLink';
import ModalConductor from '../../../components/modal/ModalConductor';
import LearningHistoryCSVForm from '../../../components/userHistory/csv/LearningHistoryCSVForm';
import SelectContentTypeDialog from '../../../components/userHistory/csv/SelectContentTypeDialog';
import { DEFAULT_DATE_FORMAT_SERVER } from '../../../constants';
import { CONTENT_TYPE_NAME, SELECTED_RANGE, TARGET_CONTENT } from '../../../constants/CSVDownloadConstant';
import { CONTENT_TYPE } from '../../../constants/ContentConstant';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import * as ModalIds from '../../../constants/ModalIds';
import { HIDE_MESSAGE } from '../../../constants/actionTypes/message';


class ProgressStatusCSVDownloadContainer extends Component {
  constructor() {
    super();
    this.state = {
      contentType: [],
      showSelectGroup: false,
      isShowSelectContentTypeDialog: false,
      showExportModal: false,
      isShowTargetUserError: false,
      isShowTargetContentError: false,
      errorUserLabel: '',
    };
    this.csvDownloadHandler = this.csvDownloadHandler.bind(this);
    this.changeTargetContentHandler = this.changeTargetContentHandler.bind(this);
    this.changeSelectedRangeHandler = this.changeSelectedRangeHandler.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.showSelectContentTypeDialog = this.showSelectContentTypeDialog.bind(this);
    this.showSelectContentLinkCourseDialog = this.showSelectContentLinkCourseDialog.bind(this);
    this.showSelectCourseBoxDialog = this.showSelectCourseBoxDialog.bind(this);
    this.cancelSelectContentTypeDialog = this.cancelSelectContentTypeDialog.bind(this);
    this.showSelectTargetUsersDialog = this.showSelectTargetUsersDialog.bind(this);
    this.okSelectContentTypeDialog = this.okSelectContentTypeDialog.bind(this);
    this.openSelectedRangeModal = this.openSelectedRangeModal.bind(this);
    this.openTargetContentModal = this.openTargetContentModal.bind(this);
    this.openExportDialog = this.openExportDialog.bind(this);
    this.onDialogExportCancel = this.onDialogExportCancel.bind(this);
    this.goBack = this.goBack.bind(this);
    this.changeProgressStatusTypeHandler = this.changeProgressStatusTypeHandler.bind(this);
    this.showSelectContentBoxDialog = this.showSelectContentBoxDialog.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(GroupAction.fetchGroupStructure());
  }

  componentWillUnmount() {
    this.props.dispatch(csvDownloadActions.resetDataForCSVDownload());
  }

  /**
   * Handle event csvDownloadHandler
   */
  csvDownloadHandler() {
    const {
      formValues,
      targetUserList,
      targetCourseList,
      targetContentList,
      targetBoxList,
    } = this.props;
    const {
      includingDormantUsers,
      selectedTargetGroupIds,
      document,
      drill,
      link,
      video,
      createdDateFrom,
      createdDateTo,
      progressStatusType,
      selectedCompletionType,
    } = formValues;
    const param = {};
    param.dormantState = !!includingDormantUsers;
    selectedTargetGroupIds && (param.groupList = selectedTargetGroupIds);
    targetUserList && (param.userList = Object.keys(targetUserList));
    targetCourseList && (param.courseList = Object.keys(targetCourseList));
    targetContentList && (param.itemList = Object.keys(targetContentList));
    targetBoxList && (param.boxList = Object.keys(targetBoxList));
    param.contentTypeList = [];
    if (video) {
      param.contentTypeList.push(CONTENT_TYPE.VIDEO);
    }
    if (drill) {
      param.contentTypeList.push(CONTENT_TYPE.DRILL);
    }
    if (document) {
      param.contentTypeList.push(CONTENT_TYPE.DOCUMENT);
    }
    if (link) {
      param.contentTypeList.push(CONTENT_TYPE.LINK);
    }
    createdDateFrom && (param.learningStartTimeFrom = moment(createdDateFrom)
    .startOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    createdDateTo && (param.learningStartTimeTo = moment(createdDateTo)
    .endOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    param.progressStatusType = progressStatusType;
    param.selectedCompletionType = selectedCompletionType;

    const isGetStatusItem = true;
    this.props.dispatch(csvDownloadActions.postGetHistoryList(param, isGetStatusItem));
    this.setState({ showExportModal: false });
  }

  /**
   * Handle event when 全コンテンツ radio button is clicked
   */
  changeTargetContentHandler(event, newValue, previousValue) {
    // Reset data
    this.props.change('video', false);
    this.props.change('drill', false);
    this.props.change('document', false);
    this.props.change('link', false);
    this.props.change('selectedCourseBox', []);
    this.props.dispatch(csvDownloadActionCreators.resetSelectedCourseBoxList());
    this.setState({ contentType: [], isShowTargetContentError: false });
  }

  /**
   * Handle event when 全体 radio button is clicked
   */
  changeSelectedRangeHandler(event, newValue, previousValue) {
    // Reset data
    this.props.change('selectedTargetGroupIds', []);
    this.props.change('includingDormantUsers', false);
    this.setState({ isShowTargetUserError: false });
    this.props.dispatch(csvDownloadActionCreators.resetSelectedGroupList());
  }

  // Step 10.0.0 START
  /**
   * Handle event when コンテンツ pulldown change value
   */
  changeProgressStatusTypeHandler() {
    this.props.change('selectedRange', '0');
    this.props.change('targetContent', '0');
    this.props.change('selectedCompletionType', '0');
  }
  // Step 10.0.0 END

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    const isLearningHistoryCSV = false;
    this.props.dispatch(csvDownloadActionCreators.changeOpenSelectGroupFlag(true));
    this.props.dispatch(csvDownloadActionCreators.changeShowGroupFlag(false, isLearningHistoryCSV));
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_GROUP_MODAL));
  }

  /**
   * Show select content type dialog
   */
  showSelectContentTypeDialog() {
    this.setState({ isShowSelectContentTypeDialog: true });
  }

  /**
   * Show select target users dialog
   */
  showSelectTargetUsersDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_SERVICE_USER_DIALOG));
  }

  /**
   * Show select course box dialog
   */
  showSelectCourseBoxDialog() {
    this.props.dispatch(csvDownloadActionCreators.changeSelectedFlag(false));
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_COURSE_DIALOG));
  }

  /**
   * Show select content link course dialog
   */
  showSelectContentLinkCourseDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_TARGET_CONTENT_DIALOG));
  }

  // Step 10.0.0 START
  /**
   * Show select box dialog
   */
  showSelectContentBoxDialog() {
    this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_TARGET_BOX_DIALOG));
  }
  // Step 10.0.0 END

  /**
   * Handle event when click on キャンセル of select content type dialog
   */
  cancelSelectContentTypeDialog() {
    const { contentType } = this.state;
    const { formValues } = this.props;
    if (formValues.video && contentType.indexOf(CONTENT_TYPE_NAME.VIDEO) === -1) {
      this.props.change('video', false);
    }
    if (formValues.drill && contentType.indexOf(CONTENT_TYPE_NAME.DRILL) === -1) {
      this.props.change('drill', false);
    }
    if (formValues.document && contentType.indexOf(CONTENT_TYPE_NAME.DOCUMENT) === -1) {
      this.props.change('document', false);
    }
    if (formValues.link && contentType.indexOf(CONTENT_TYPE_NAME.LINK) === -1) {
      this.props.change('link', false);
    }

    if (!formValues.video && contentType.indexOf(CONTENT_TYPE_NAME.VIDEO) > -1) {
      this.props.change('video', true);
    }
    if (!formValues.drill && contentType.indexOf(CONTENT_TYPE_NAME.DRILL) > -1) {
      this.props.change('drill', true);
    }
    if (!formValues.document && contentType.indexOf(CONTENT_TYPE_NAME.DOCUMENT) > -1) {
      this.props.change('document', true);
    }
    if (!formValues.link && contentType.indexOf(CONTENT_TYPE_NAME.LINK) > -1) {
      this.props.change('link', true);
    }
    this.setState({ isShowSelectContentTypeDialog: false });
  }

  /**
   * Handle event when click on OK of select content type dialog
   */
  okSelectContentTypeDialog() {
    const { formValues } = this.props;
    const contentType = [];
    if (formValues.video) {
      contentType.push(CONTENT_TYPE_NAME.VIDEO);
    }
    if (formValues.drill) {
      contentType.push(CONTENT_TYPE_NAME.DRILL);
    }
    if (formValues.document) {
      contentType.push(CONTENT_TYPE_NAME.DOCUMENT);
    }
    if (formValues.link) {
      contentType.push(CONTENT_TYPE_NAME.LINK);
    }
    this.setState({ isShowSelectContentTypeDialog: false, contentType: [...contentType] });
  }

  /**
   * Handle event when click on 選択 button of SELECTED_RANGE
   */
  openSelectedRangeModal() {
    const { formValues } = this.props;
    const { selectedRange } = formValues;
    if (selectedRange === SELECTED_RANGE.GROUP) {
      this.showSelectGroupDlg();
    } else if (selectedRange === SELECTED_RANGE.USER) {
      this.showSelectTargetUsersDialog();
    }
  }

  /**
   * Handle event when click on 選択 button of TARGET_CONTENT
   */
  openTargetContentModal() {
    const { formValues } = this.props;
    const { targetContent } = formValues;
    if (targetContent === TARGET_CONTENT.COURSE) {
      this.showSelectCourseBoxDialog();
    } else if (targetContent === TARGET_CONTENT.CONTENT_TYPE) {
      this.showSelectContentTypeDialog();
    } else if (targetContent === TARGET_CONTENT.CONTENT_SPECIFICATION) {
      this.showSelectContentLinkCourseDialog();
    } else if (targetContent === TARGET_CONTENT.BOX) {
      this.showSelectContentBoxDialog();
    }
  }

  /**
   * Handle open export dialog
   */
  openExportDialog(mdContent, mdSize) {
    const {
      formValues,
      targetUserList,
      targetCourseList,
      targetContentList,
      targetBoxList,
    } = this.props;
    const {
      includingDormantUsers,
      selectedTargetGroupIds,
      document,
      drill,
      link,
      video,
      createdDateFrom,
      createdDateTo,
      selectedRange,
      targetContent,
    } = formValues;
    let checkTargetUser = true;
    let checkTargetContent = true;
    this.content = mdContent;
    this.mdSize = mdSize;

    const contentTypeLists = [];
    if (video) {
      contentTypeLists.push(CONTENT_TYPE.VIDEO);
    }
    if (drill) {
      contentTypeLists.push(CONTENT_TYPE.DRILL);
    }
    if (document) {
      contentTypeLists.push(CONTENT_TYPE.DOCUMENT);
    }
    if (link) {
      contentTypeLists.push(CONTENT_TYPE.LINK);
    }

    if (selectedRange !== SELECTED_RANGE.ALL || targetContent !== TARGET_CONTENT.ALL) {
      if (selectedRange !== SELECTED_RANGE.ALL) {
        if (!(selectedTargetGroupIds && selectedTargetGroupIds.length) &&
          !(Object.keys(targetUserList) && Object.keys(targetUserList).length)) {
          let errorLabel = '';
          selectedRange === SELECTED_RANGE.GROUP ? errorLabel = 'ユーザーグループ'
          : errorLabel = 'ユーザー';
          this.setState({ isShowTargetUserError: true, errorUserLabel: errorLabel, showExportModal: false });
          this.props.dispatch({ type: HIDE_MESSAGE });
          checkTargetUser = false;
        } else {
          checkTargetUser = true;
          this.setState({ isShowTargetUserError: false, errorUserLabel: '' });
        }
      }

      if (targetContent !== TARGET_CONTENT.ALL) {
        if (!(Object.keys(targetCourseList) && Object.keys(targetCourseList).length) &&
          !(Object.keys(targetContentList) && Object.keys(targetContentList).length) &&
          !(contentTypeLists && contentTypeLists.length) &&
          !(Object.keys(targetBoxList) && Object.keys(targetBoxList).length)) {
          let errorLabel = '';
          switch (targetContent) {
            case TARGET_CONTENT.COURSE:
              errorLabel = 'コース';
              break;
            case TARGET_CONTENT.CONTENT_SPECIFICATION:
              errorLabel = 'コンテンツ';
              break;
            case TARGET_CONTENT.CONTENT_TYPE:
              errorLabel = 'コンテンツ種別';
              break;
            case TARGET_CONTENT.BOX:
              errorLabel = 'セクション';
              break;
            default:
          }
          this.setState({ isShowTargetContentError: true, errorContentLabel: errorLabel, showExportModal: false });
          this.props.dispatch({ type: HIDE_MESSAGE });
          checkTargetContent = false;
        } else {
          checkTargetContent = true;
          this.setState({ isShowTargetContentError: false, errorContentLabel: '' });
        }
      }
    }

    if (checkTargetContent && checkTargetUser) {
      this.setState({ showExportModal: true });
    }
  }

  /**
   * Handle Cancel button on export dialog
   */
  onDialogExportCancel() {
    this.setState({ showExportModal: false });
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { formValues, learningHistoryCSVDownload } = this.props;
    const { authedUser: { dormantUserDataAcquisitionPermissionFlag } } = this.props;

    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          text="戻る"
          icon="bi bi-chevron-left"
          onClick={this.goBack}
        />
        <Header name="進捗状況情報のダウンロード" />
        <LearningHistoryCSVForm
          {...formValues}
          isShowTargetUserError={this.state.isShowTargetUserError}
          isShowTargetContentError={this.state.isShowTargetContentError}
          errorContentLabel={this.state.errorContentLabel}
          errorUserLabel={this.state.errorUserLabel}
          isProgressStatusCSVDownloadContainer={true}
          isSelected={this.props.isSelected}
          isShowGroupNumber={this.props.isShowGroupNumber}
          contentType={this.state.contentType}
          csvDownloadHandler={this.csvDownloadHandler}
          changeTargetContentHandler={this.changeTargetContentHandler}
          changeSelectedRangeHandler={this.changeSelectedRangeHandler}
          showSelectGroupDlg={this.showSelectGroupDlg}
          showSelectTargetUsersDialog={this.showSelectTargetUsersDialog}
          showSelectCourseBoxDialog={this.showSelectCourseBoxDialog}
          showSelectContentTypeDialog={this.showSelectContentTypeDialog}
          showSelectContentLinkCourseDialog={this.showSelectContentLinkCourseDialog}
          openSelectedRangeModal={this.openSelectedRangeModal}
          openTargetContentModal={this.openTargetContentModal}
          openExportDialog={this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT_USER_HISTORY, null)}
          dormantUserDataAcquisitionPermissionFlag={dormantUserDataAcquisitionPermissionFlag}
          changeProgressStatusTypeHandler={this.changeProgressStatusTypeHandler}
        />
        <SelectContentTypeDialog
          showModal={this.state.isShowSelectContentTypeDialog}
          onCancel={this.cancelSelectContentTypeDialog}
          onOK={this.okSelectContentTypeDialog}
        />
        <ModalConductor />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onDialogExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.csvDownloadHandler}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const {
    learningHistoryCSVDownload,
    isSelected,
    isShowGroupNumber,
    targetCourseList,
    targetUserList,
    targetContentList,
    targetBoxList,
  } = state.csvDownload;
  const { authedUser } = state.authed;
  const formValues = getFormValues('progressStatusCSVDownload')(state);

  return {
    ...{ learningHistoryCSVDownload },
    formValues,
    initialValues: learningHistoryCSVDownload,
    isSelected,
    isShowGroupNumber,
    targetCourseList,
    targetUserList,
    targetContentList,
    targetBoxList,
    authedUser,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'progressStatusCSVDownload', // a unique identifier for this form
  touchOnChange: true,
})(ProgressStatusCSVDownloadContainer));
